module.exports = __webpack_public_path__ + "static/year2009-4b0e2ee830fa4bfedbc565ce5d31e5f4.jpg";